import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sortBy } from 'lodash'
import React, { FC, useEffect, useMemo, useState } from 'react'
import Tips from '../../common/Tips'
import { compile } from '../../../../utils/search'

interface Props {
  memberIdList: number[]
  callbackMembers: (teams: { id: number, name: string }[]) => void
  memberList: { id: number, name: string, profile_image: string | null, active: boolean }[]
  isClear?: boolean
}

const AddMemberModule: FC<Props> = (props) => {
  const {
    memberIdList,
    callbackMembers,
    memberList,
    isClear,
  } = props

  const [isSearchDisplay, setIsSearchDisplay] = useState(false)
  const [selectMembers, setSelectMembers] = useState<{id: number, name: string}[]>([])

  const [members, setMembers] = useState<{id: number, name: string, profile_image: string | null, active: boolean}[]>([])
  const [searchMemberWord, setSearchMemberWord] = useState<string>("")

  const membersInit = useMemo(() => (
    memberList || []
  ), [memberList])

  const getUniqueValues = ([...array]) => (
    array.filter((value, _index, self) => self.indexOf(value) === self.lastIndexOf(value))
  )

  const clickMember = (member_id: number) => {
    if (selectMembers.map((v) => v.id).includes(member_id)) {
      setSelectMembers(selectMembers.filter((v) => v.id !== member_id))
    } else {
      setSelectMembers([...selectMembers, { id: member_id, name: members.find((v) => v.id === member_id)?.name || "" }])
    }
  }

  const searchMember = (words: string) => {
    setSearchMemberWord(words)
    if (!words) {
      setMembers([...membersInit])
      return
    }
    const word = words.toLowerCase().split(/\s+/)
    const list = membersInit.filter((member) => {
      if (member === null) return false
      return (compile(word).test(member.name.toLowerCase())) || selectMembers.map((v) => v.id)?.includes(member.id)
    })
    setMembers(sortBy(list, 'id'))
  }

  const resetMember = () => {
    setSearchMemberWord("")
    setMembers([...membersInit])
  }

  const openSearch = () => {
    setIsSearchDisplay(true)
  }

  const closeSearch = () => {
    setIsSearchDisplay(false)
    resetMember()
    if (!getUniqueValues([...selectMembers.map((v) => v.id), ...memberIdList]).length) return
    callbackMembers(selectMembers)
  }

  useEffect(() => {
    setMembers(memberList || [])
  }, [memberList])

  useEffect(() => {
    if (!members) return
    setSelectMembers(members.filter((v) => memberIdList?.includes(v.id)))
  }, [memberIdList, members])

  useEffect(() => {
    if (!isClear) return
    setSelectMembers([])
  }, [isClear])

  return (
    <>
      <div
        className="add_button"
        onClick={() => openSearch()}
        role="none"
      >
        <FontAwesomeIcon icon={['fas', 'plus']} />
        &nbsp;
        追加
        <div className={`search_box ${isSearchDisplay || 'none'}`}>
          <div className="search_detail">
            <div className="category">
              <div className="category_title">
                メンバー
                {
                  selectMembers.length ? (
                    <div
                      className="select_reset"
                      role="none"
                      onClick={() => setSelectMembers([])}
                    >
                      リセット
                    </div>
                  ) : (
                    <></>
                  )
                }
              </div>
              <div className="search_area">
                <FontAwesomeIcon
                  icon={['fas', 'search']}
                  className="icon"
                />
                <input
                  type="text"
                  placeholder="メンバーを検索"
                  onChange={(event) => searchMember(event.target.value)}
                  value={searchMemberWord}
                />
                {
                  searchMemberWord && (
                    <button type="button" className="reset" onClick={resetMember}>
                      <FontAwesomeIcon icon={['far', 'times-circle']} />
                    </button>
                  )
                }
              </div>
              {
                members.map((member) => (
                  <button
                    type="button"
                    className={`chip ${selectMembers.map((v) => v.id).includes(member.id) ? "checked" : ""}`}
                    key={`member_${member.id}`}
                    onClick={() => clickMember(member.id)}
                  >
                    {
                      member.profile_image ? (
                        <img
                          alt="profile"
                          src={member.profile_image}
                          className="profile_icon"
                          style={{
                            borderRadius: "50%",
                            width: "20px",
                          }}
                        />
                      ) : (
                        <img
                          alt=""
                          src={`/static/images/profile/${(Number(member.id) || 0) % 12}.jpeg`}
                          className="profile_icon"
                          style={{
                            borderRadius: "50%",
                            width: "20px",
                          }}
                        />
                      )
                    }
                    {member.name}
                    {
                      member.active || (
                        <Tips
                          description="休眠中💤"
                          className=""
                          icon={false}
                        >
                          <>
                            💤
                          </>
                        </Tips>
                      )
                    }
                  </button>
                ))
              }
            </div>
          </div>
        </div>
      </div>
      <div className={`close_screen ${isSearchDisplay || 'none'}`} role="presentation" onClick={() => closeSearch()} />
    </>
  )
}

AddMemberModule.defaultProps = {
  isClear: false,
}

export default AddMemberModule
